@if (visible) {
  <div class="profile-image" ngbDropdown (click)="$event.stopPropagation()">
    <div ngbDropdownToggle aria-haspopup="true" aria-expanded="false" data-offset="10,10" style="width: 45px;">
      @if (!impersonatedAvatarUrl) {
        <img [src]="sanitizer.bypassSecurityTrustResourceUrl(avatarUrl)" alt="foto-usuario" [@zoomout]="isImpersonating">
      } @else {
        <img [src]="sanitizer.bypassSecurityTrustResourceUrl(impersonatedAvatarUrl)" alt="foto-usuario" [@zoomin]="isImpersonating">
      }
    </div>
    <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="avatar" style="margin-left: -110px">
        <button class="dropdown-item" (click)="logout($event)">Cerrar Sesión</button>
    </div>
  </div>
}
